module.exports = __webpack_public_path__ + "img/ulkotila_thumbnail_x2.bdc10d03.jpg";